import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSelectChange } from "@angular/material/select";
import { Observable, Subscription } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { SimNaoDialogComponent } from "src/app/components/dialogs/sim-nao-dialog/sim-nao-dialog.component";
import { ReferenciaDialogComponent } from "src/app/components/popups/referencia-dialog/referencia-dialog.component";
import { EnumTipoReferencia } from "src/app/enums/EnumTipoReferencia";
import { StringHelper } from "src/app/helpers/string.helper";
import { Referencia } from "src/app/models/Referencia";
import { ReferenciaCabecalho } from "src/app/models/ReferenciaCabecalho";
import { ReferenciaGerenciada } from "src/app/models/ReferenciaGerenciada";
import { UsuarioReferenciaService } from "src/app/services/data-services/usuario.referencia.service";
import { StatusService } from "src/app/services/status.service";
import { TextFormatingService } from "src/app/services/ui/textFormating.service";
@Component({
  selector: "app-editor-referencia",
  templateUrl: "./editor-referencia.component.html",
  styleUrls: ["./editor-referencia.component.scss"],
})
export class EditorReferenciaComponent implements OnInit, OnDestroy {
  @Input() referencia: Referencia;
  @Input() referencias: Referencia[];
  @Input() referenciaReadOnly: boolean;
  @Output() onSalvarReferencia = new EventEmitter<Referencia>();
  @Output() onFechaReferencia = new EventEmitter<Referencia>();
  @Output() onDeletaReferencia = new EventEmitter<Referencia>();

  public fontIncrement: Observable<number>;
  public carregandoReferencias = false;
  public carregandoReferenciasPorId = false;
  public novaReferencia = false;
  public referenciasexistentes: ReferenciaCabecalho[] = [];
  public opcao: Referencia;
  public referenciaControl = new FormControl();
  public referenciaOptions: Observable<ReferenciaCabecalho[]>;
  public referenciaAlterada = false;
  private subscriptions: Subscription[] = [];

  constructor(
    private changeDetector: ChangeDetectorRef,
    public dialog: MatDialog,
    private textFormatingService: TextFormatingService,
    private usuarioReferenciaService: UsuarioReferenciaService,
    private statusService: StatusService
  ) {}
  @Input() set referenciasGerenciadasReadOnly(
    referenciasGerenciadasReadOnly: ReferenciaGerenciada[]
  ) {
    this.referencias = Referencia.referenciaParceGerenciada(
      referenciasGerenciadasReadOnly
    );
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((x) => x.unsubscribe());
  }

  ngOnInit() {
    this.fontIncrement = this.textFormatingService.getFontIncrement();

    this.referenciaOptions = this.referenciaControl.valueChanges.pipe(
      startWith(""),
      map((value) => (typeof value === "string" ? value : value.ref)),
      map((ref) =>
        ref ? this._filter(ref) : this.referenciasexistentes?.slice()
      )
    );
  }

  displayFn(referencia: ReferenciaCabecalho): string {
    return referencia && referencia.ref ? referencia.ref : "";
  }

  public confirmarDelecaoReferencia(referencia: Referencia) {
    const dialogRef = this.dialog.open(SimNaoDialogComponent, {
      width: "250px",
      data: "Deseja mesmo excluir a referência?",
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.onDeletaReferencia.emit(referencia);
        this.changeDetector.markForCheck();
      }
    });
  }

  salvarReferencia() {
    if (
      this.referencia?.conteudo &&
      this.referencia?.ref &&
      Number.isInteger(this.referencia?.tipo)
    ) {
      const cont = this.opcao?.links.findIndex(
        (x) =>
          x.idItem === this.referencia.links[0].idItem &&
          x.idLei === this.referencia.links[0].idLei
      );
      if (cont === -1) {
        this.referencia.links.push(...this.opcao.links);
      } else if (cont) {
        this.referencia.links = this.opcao.links;
      }

      this.onSalvarReferencia.emit(this.referencia);
      this.opcao = null;
      this.referencia = null;
      this.carregandoReferencias = false;
      this.carregandoReferenciasPorId = false;
      this.novaReferencia = false;
      this.referenciaAlterada = false;
      this.changeDetector.markForCheck();
    }
  }

  fechaReferencia() {
    this.onFechaReferencia.emit();
    this.opcao = null;
    this.referencia = null;
    this.carregandoReferencias = false;
    this.carregandoReferenciasPorId = false;
    this.novaReferencia = false;
    this.referenciaAlterada = false;
    this.changeDetector.markForCheck();
  }

  public confirmarCloseReferencia() {
    const dialogRef = this.dialog.open(SimNaoDialogComponent, {
      width: "250px",
      data: "Deseja mesmo fechar a tela de criação de referência?",
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.fechaReferencia();
        this.opcao = null;
        this.referencia = null;
        this.carregandoReferencias = false;
        this.carregandoReferenciasPorId = false;
        this.novaReferencia = false;
        this.referenciaAlterada = false;
        this.changeDetector.markForCheck();
      }
    });
  }

  openDialog(referencia: Referencia): void {
    const dialogRef = this.dialog.open(ReferenciaDialogComponent, {
      data: {
        referencia: referencia,
        tipo: Referencia.identificarTipoReferencia(referencia.tipo),
        referenciaReadOnly: this.referenciaReadOnly,
      },
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }
  tipoReferencia(item: EnumTipoReferencia) {
    return Referencia.identificarTipoReferencia(item);
  }

  public atualizarDicas(dica: string) {
    this.referencia.conteudo = dica;
  }

  public async buscarReferencias() {
    this.referenciasexistentes = this.statusService.getIsAppOnline()
      ? await this.usuarioReferenciaService.carregarReferenciasCabecalho()
      : await this.usuarioReferenciaService.buscarReferenciasCabecalhoLocal();
    this.carregandoReferencias = true;
    this.changeDetector.detectChanges();

    return false;
  }

  public async selecionarReferenciaExistente(opcao: ReferenciaCabecalho) {
    this.carregandoReferenciasPorId = true;
    const referencia = this.statusService.getIsAppOnline()
      ? await this.usuarioReferenciaService.carregarReferenciaPorId(opcao.id)
      : await this.usuarioReferenciaService.buscarReferenciaLocalPorId(
        opcao.id
      );

    this.opcao = new Referencia({
      id: referencia.id,
      dataHoraModificacao: opcao.dataHoraModificacao,
      removido: referencia.removido,
      conteudo: referencia.conteudo,
      tipo: referencia.tipo,
      ref: referencia.ref,
      link: referencia.link,
      links: this.referencia.links,
    });
    this.novaReferencia = true;
    this.referencia = referencia;
    this.changeDetector.detectChanges();
    this.carregandoReferenciasPorId = false;
    this.referenciaAlterada = true;
  }

  public selecionarTipoReferenciaExistente(opcao: MatSelectChange) {
    const numero = parseInt(opcao.value, 10);

    if (!isNaN(numero) && numero in EnumTipoReferencia) {
      this.referencia.tipo = numero as EnumTipoReferencia;
    }

    this.changeDetector.markForCheck();
  }

  public gerarnovaReferencia() {
    this.novaReferencia = true;
    const referen = new Referencia();

    referen.links = this.referencia.links;

    this.referencia = referen;
    this.referenciaAlterada = true;
    this.changeDetector.markForCheck();
  }

  private _filter(ref: string): ReferenciaCabecalho[] {
    const filterValue = StringHelper.Normalize(ref);

    return this.referenciasexistentes.filter((option) =>
      StringHelper.Normalize(option.ref).includes(filterValue)
    );
  }
}
